// Mock data for Trademark Registration Website

export const businessInfo = {
  name: "Trademark Restaurant Name",
  email: "info@trademarkrestaurantname.com",
  phone: "+1 (123) 123-4567",
  address: "2700 Colorado Ave, Santa Monica, CA 90404"
};

export const heroData = {
  title: "Protect Your Brand with Expert Trademark Registration",
  subtitle: "Secure your business identity with comprehensive trademark registration services. USPTO-approved filings with a 95% success rate.",
  image: "https://images.pexels.com/photos/7876314/pexels-photo-7876314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ctaText: "Register My Trademark",
  secondaryCta: "Get Free Consultation"
};

export const aboutData = {
  title: "Leading Trademark Registration Experts",
  description: "With over a decade of experience in intellectual property law, we specialize exclusively in trademark registration services across the United States. Our USPTO-registered attorneys have successfully filed over 1,000 trademarks, protecting brands in every industry.",
  highlights: [
    "1,000+ Trademarks Successfully Registered",
    "95% USPTO Approval Rate",
    "10+ Years of Legal Experience",
    "Comprehensive Brand Protection"
  ]
};

export const servicesData = {
  title: "Comprehensive Trademark Registration Services",
  subtitle: "End-to-end trademark protection solutions tailored to your business needs",
  services: [
    {
      title: "Trademark Search & Clearance",
      description: "Before filing your trademark application, we conduct exhaustive searches across federal, state, and common law databases to identify potential conflicts. Our comprehensive analysis includes USPTO records, state trademark registries, business name databases, domain name registrations, and common law usage. We provide detailed clearance reports with risk assessments and recommendations to strengthen your application and minimize rejection risk.",
      features: ["USPTO Federal Database Search", "All 50 State Registry Review", "Common Law Usage Analysis", "Domain Name Availability Check", "Social Media Handle Search", "Likelihood of Confusion Assessment", "Detailed Clearance Report", "Risk Mitigation Strategies"]
    },
    {
      title: "Trademark Application Filing",
      description: "Expert preparation and filing of your trademark application with the USPTO. Our experienced attorneys ensure accurate classification of goods and services, prepare compelling descriptions that maximize protection scope, select proper filing basis, and submit high-quality specimens. We handle both use-based and intent-to-use applications, managing every detail to optimize approval chances and establish strong trademark rights.",
      features: ["Complete Application Preparation", "Accurate Class Selection (45 Classes)", "Specimen Creation & Submission", "USPTO Electronic Filing", "Filing Receipt & Tracking Number", "Design Mark Descriptions", "Multiple Class Filings", "Priority Filing Services"]
    },
    {
      title: "Office Action Response",
      description: "When the USPTO issues an office action raising concerns about your application, our skilled trademark attorneys provide expert responses to overcome objections. We handle substantive refusals based on likelihood of confusion, descriptiveness issues, ornamental refusals, and procedural deficiencies. Our legal team crafts persuasive arguments supported by case law and evidence, working to successfully advance your application to registration.",
      features: ["Expert Legal Analysis", "Comprehensive Response Drafting", "Evidence & Case Law Research", "Amendment Preparation", "Examiner Interview Requests", "Disclaimer Negotiation", "Supplemental Arguments", "Continued Prosecution Strategy"]
    },
    {
      title: "Trademark Monitoring & Maintenance",
      description: "Ongoing protection doesn't end at registration. We provide comprehensive monitoring services to detect potential infringers and protect your trademark rights. Our services include watch services for new conflicting applications, marketplace monitoring for unauthorized use, renewal deadline tracking, and maintenance filing preparation. We help you maintain trademark strength through continuous use documentation and enforcement support when needed.",
      features: ["Trademark Watch Services", "Infringement Monitoring", "Marketplace Surveillance", "Renewal Deadline Reminders", "Section 8 & 9 Filings", "Section 15 Incontestability Filing", "Cease & Desist Letter Drafting", "Opposition & Cancellation Support"]
    }
  ]
};

export const processData = {
  title: "Our Proven Trademark Registration Process",
  subtitle: "A streamlined 3-step approach to secure your brand",
  steps: [
    {
      number: "01",
      title: "Consultation & Search",
      description: "We discuss your brand needs and conduct a comprehensive trademark search across USPTO databases, state registries, and common law sources to identify potential conflicts and ensure your mark is available for registration."
    },
    {
      number: "02",
      title: "Application & Filing",
      description: "Our expert team prepares your trademark application with precise classifications, detailed descriptions, and proper specimens. We then electronically file with the USPTO and monitor the examination process, responding to any office actions with expert legal arguments."
    },
    {
      number: "03",
      title: "Registration & Protection",
      description: "Once approved by the USPTO, your trademark is officially registered and published. We provide your registration certificate and offer ongoing monitoring and maintenance services to protect your brand rights and ensure long-term trademark security."
    }
  ]
};

export const pricingData = {
  title: "Transparent Trademark Registration Pricing",
  subtitle: "Choose the package that fits your brand protection needs",
  note: "All plans exclude government filing fees",
  plans: [
    {
      name: "Essentials",
      price: "$45",
      period: "+ Federal Filing Fee",
      description: "Basic trademark filing for simple applications",
      features: [
        "Case Review",
        "Case Filing",
        "Basic Search",
        "State E-Filing",
        "Trademark Secured"
      ],
      note: "Govt. filing fee not included",
      cta: "Get Started",
      popular: false
    },
    {
      name: "Enhanced",
      price: "$149",
      period: "+ Federal Filing Fee",
      description: "Comprehensive filing with search and monitoring",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter"
      ],
      note: "Govt. filing fee not included",
      cta: "Get Started",
      popular: false
    },
    {
      name: "Deluxe",
      price: "$299",
      period: "+ Federal Filing Fee",
      description: "Complete trademark protection with dedicated support",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager"
      ],
      note: "Govt. filing fee not included",
      cta: "Get Started",
      popular: true,
      recommended: true
    },
    {
      name: "Platinum",
      price: "$349",
      period: "+ Federal Filing Fee",
      description: "Premium service with priority processing",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager",
        "High Approval Rate",
        "Comprehensive Search Report",
        "High Priority Service",
        "Cease & Desist Letter"
      ],
      note: "Govt. filing fee not included",
      cta: "Get Started",
      popular: false
    }
  ]
};

export const industriesData = {
  title: "Industries We Serve",
  subtitle: "Protecting brands across all business sectors with specialized trademark expertise",
  image: "https://images.pexels.com/photos/7108269/pexels-photo-7108269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  industries: [
    { 
      name: "Restaurants & Food Services", 
      icon: "UtensilsCrossed",
      description: "Protecting restaurant names, menu items, and culinary brands from local eateries to national chains."
    },
    { 
      name: "Technology & Software", 
      icon: "Laptop",
      description: "Securing app names, software brands, SaaS products, and tech innovations in the digital marketplace."
    },
    { 
      name: "Retail & E-commerce", 
      icon: "ShoppingBag",
      description: "Trademark protection for online stores, retail brands, product lines, and marketplace sellers."
    },
    { 
      name: "Healthcare & Medical", 
      icon: "Heart",
      description: "Safeguarding medical practices, healthcare services, pharmaceutical brands, and wellness products."
    },
    { 
      name: "Professional Services", 
      icon: "Briefcase",
      description: "Protecting consulting firms, legal practices, accounting services, and business advisory brands."
    },
    { 
      name: "Entertainment & Media", 
      icon: "Film",
      description: "Trademark registration for production companies, podcasts, streaming services, and content creators."
    },
    { 
      name: "Fashion & Apparel", 
      icon: "Shirt",
      description: "Securing clothing brands, fashion labels, accessory lines, and designer collections."
    },
    { 
      name: "Real Estate", 
      icon: "Building",
      description: "Protecting real estate agencies, property management brands, and development company names."
    },
    { 
      name: "Automotive", 
      icon: "Car",
      description: "Trademark services for auto dealerships, repair shops, parts manufacturers, and vehicle brands."
    },
    { 
      name: "Beauty & Cosmetics", 
      icon: "Sparkles",
      description: "Securing cosmetic brands, beauty products, salon names, and skincare lines."
    },
    { 
      name: "Education & Training", 
      icon: "GraduationCap",
      description: "Protecting educational institutions, online courses, training programs, and certification brands."
    },
    { 
      name: "Manufacturing", 
      icon: "Factory",
      description: "Trademark registration for manufacturing brands, industrial products, and equipment names."
    },
    { 
      name: "Fitness & Wellness", 
      icon: "Dumbbell",
      description: "Protecting gym brands, fitness programs, wellness centers, and health supplement lines."
    },
    { 
      name: "Hospitality & Tourism", 
      icon: "Hotel",
      description: "Securing hotel brands, travel services, tour operators, and hospitality businesses."
    },
    { 
      name: "Financial Services", 
      icon: "DollarSign",
      description: "Trademark protection for fintech apps, investment firms, insurance brands, and banking services."
    },
    { 
      name: "Home & Garden", 
      icon: "Home",
      description: "Protecting home improvement brands, gardening products, furniture lines, and decor businesses."
    }
  ]
};

export const benefitsData = {
  title: "Benefits of Trademark Registration",
  subtitle: "Why federal trademark registration is essential for your business",
  benefits: [
    {
      title: "Exclusive Legal Rights",
      description: "Federal registration grants you exclusive nationwide rights to use your trademark in connection with your goods or services, preventing others from using confusingly similar marks."
    },
    {
      title: "Legal Presumption of Ownership",
      description: "Registration provides legal presumption that you own the mark and have the exclusive right to use it nationwide, making infringement cases much easier to prove."
    },
    {
      title: "Use of ® Symbol",
      description: "Only federally registered trademarks can use the ® symbol, signaling to competitors and customers that your brand is officially protected."
    },
    {
      title: "Enhanced Brand Value",
      description: "A registered trademark is a valuable business asset that increases your company's valuation and can be licensed, franchised, or sold."
    },
    {
      title: "Federal Court Access",
      description: "Registration allows you to bring infringement lawsuits in federal court and potentially recover profits, damages, and attorney fees."
    },
    {
      title: "Customs Protection",
      description: "Record your trademark with U.S. Customs to prevent importation of infringing or counterfeit goods from entering the country."
    }
  ]
};

export const trustData = {
  title: "Why Choose Us",
  subtitle: "Your trusted partner in comprehensive trademark protection and brand security",
  image: "https://images.pexels.com/photos/7926210/pexels-photo-7926210.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  achievements: [
    { number: "1000+", label: "Trademarks Filed" },
    { number: "95%", label: "Approval Rate" },
    { number: "10+", label: "Years Experience" },
    { number: "500+", label: "Happy Clients" }
  ],
  reasons: [
    {
      title: "USPTO-Registered Trademark Attorneys",
      description: "Our team consists exclusively of USPTO-registered attorneys with specialized expertise in trademark law and intellectual property protection. Each attorney has successfully prosecuted hundreds of trademark applications and brings extensive experience navigating complex USPTO examination procedures, responding to office actions, and securing registrations for diverse business sectors."
    },
    {
      title: "Comprehensive Search & Analysis",
      description: "We conduct the most thorough trademark searches in the industry, examining not just federal databases but also all 50 state registries, common law uses, domain registrations, social media handles, and business name databases. Our detailed clearance reports include risk assessments, conflict analysis, and strategic recommendations to strengthen your application and maximize approval chances while minimizing future legal disputes."
    },
    {
      title: "Transparent, All-Inclusive Pricing",
      description: "No hidden fees, surprise charges, or unclear billing. Our straightforward pricing includes everything you need for trademark registration at each service level. We clearly separate our professional fees from government filing fees, provide detailed invoices, and offer flexible payment options. You'll know exactly what you're paying for before we begin, with no unexpected costs along the way."
    },
    {
      title: "Dedicated Case Management",
      description: "Every client receives personalized attention from a dedicated case manager who serves as your single point of contact throughout the entire trademark registration process. Your case manager proactively communicates updates, answers questions promptly, explains complex legal concepts in plain English, and ensures you're informed at every stage from initial filing through final registration."
    },
    {
      title: "Fast, Efficient Processing",
      description: "We understand that time is critical in trademark protection. Our streamlined processes and experienced team enable us to prepare and file applications within 24-48 hours of receiving complete information. We monitor your application status daily, respond to USPTO office actions within the optimal timeframe, and take proactive steps to expedite your registration whenever possible."
    },
    {
      title: "Proven Track Record of Success",
      description: "With over 1,000 successful trademark registrations and a 95% USPTO approval rate, our results speak for themselves. We've successfully handled complex refusals, overcome difficult office actions, and secured registrations in highly competitive trademark classes. Our expertise spans startups to Fortune 500 companies across every industry, consistently delivering successful outcomes."
    },
    {
      title: "Ongoing Protection & Support",
      description: "Our commitment doesn't end when your trademark registers. We provide comprehensive post-registration support including trademark monitoring to detect potential infringers, renewal deadline reminders to maintain your rights, guidance on proper trademark usage, assistance with enforcement matters, and ongoing strategic advice to maximize your trademark portfolio's value over time."
    },
    {
      title: "Strategic Brand Protection Counsel",
      description: "Beyond registration, we serve as strategic advisors helping you build and protect a strong trademark portfolio. We provide guidance on brand selection, trademark strength analysis, portfolio management strategies, international expansion considerations, licensing opportunities, and enforcement options. Our goal is to help you maximize the value and protection of your intellectual property assets."
    }
  ]
};

export const faqData = {
  title: "Frequently Asked Questions",
  subtitle: "Everything you need to know about trademark registration",
  faqs: [
    {
      question: "What is a trademark and why do I need one?",
      answer: "A trademark is a symbol, word, or phrase that identifies your goods or services. Federal registration provides nationwide protection, legal ownership presumption, and exclusive rights to use the mark in commerce."
    },
    {
      question: "How long does the trademark registration process take?",
      answer: "The entire process typically takes 8-12 months from filing to registration. The USPTO assigns an examining attorney within 3-4 months. If approved, the mark is published for opposition (30 days) and then registered."
    },
    {
      question: "What can be registered as a trademark?",
      answer: "You can register words, names, slogans, logos, symbols, designs, sounds, and colors. The mark must be distinctive and not merely descriptive. It cannot be confusingly similar to existing marks."
    },
    {
      question: "How much does trademark registration cost?",
      answer: "Our service fees range from $45 to $349 depending on the package. USPTO filing fees are $250-$350 per class. Total cost typically ranges from $295 to $700 for basic registration."
    },
    {
      question: "What is a trademark class?",
      answer: "Trademark classes categorize goods and services. There are 45 international classes. Each class requires a separate filing fee. Most businesses need 1-3 classes."
    },
    {
      question: "Do I need to use my trademark before filing?",
      answer: "No. You can file an 'Intent-to-Use' application before using the mark. However, you must demonstrate actual use before the USPTO will register it."
    },
    {
      question: "How long does trademark protection last?",
      answer: "A registered trademark can last indefinitely with proper maintenance. File maintenance documents between years 5-6, 9-10, and every 10 years thereafter."
    },
    {
      question: "What is an office action?",
      answer: "An office action is a letter from the USPTO identifying application issues. Common issues include likelihood of confusion or descriptiveness. Our attorneys respond to overcome objections."
    }
  ]
};

export const ctaData = {
  title: "Protect Your Brand Today",
  subtitle: "Don't wait until it's too late. Secure your trademark and safeguard your business identity with expert legal support.",
  urgency: "Limited Time: Free consultation for new clients this month",
  ctaText: "Register My Trademark Now",
  secondaryCta: "Schedule Free Consultation"
};

export const countryCodes = [
  { code: "+1", country: "US/Canada" },
  { code: "+44", country: "UK" },
  { code: "+61", country: "Australia" },
  { code: "+91", country: "India" },
  { code: "+86", country: "China" },
  { code: "+33", country: "France" },
  { code: "+49", country: "Germany" },
  { code: "+81", country: "Japan" },
  { code: "+82", country: "South Korea" },
  { code: "+52", country: "Mexico" },
  { code: "+55", country: "Brazil" },
  { code: "+34", country: "Spain" },
  { code: "+39", country: "Italy" }
];

// Mock submissions storage
export const mockSubmissions = [];

export const submitContactForm = (formData) => {
  const submission = {
    id: Date.now(),
    ...formData,
    timestamp: new Date().toISOString()
  };
  mockSubmissions.push(submission);
  console.log("Form submitted:", submission);
  console.log("All submissions:", mockSubmissions);
  return { success: true, data: submission };
};
